module.exports = __webpack_public_path__ + "static/media/DSC00297.ca283f27.jpg";